import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, injectIntl, intlShape } from 'react-intl';

import GreenFlag from '../green-flag/green-flag.jsx';
import StopAll from '../stop-all/stop-all.jsx';

import ToCode from '../tocode/tocode.jsx';
import CodePanel from '../code-panel/code-panel.jsx';
import TurboMode from '../turbo-mode/turbo-mode.jsx';

import styles from './controls.css';
const messages = defineMessages({
    goTitle: {
        id: 'gui.controls.go',
        defaultMessage: 'Go',
        description: 'Green flag button title'
    },
    stopTitle: {
        id: 'gui.controls.stop',
        defaultMessage: 'Stop',
        description: 'Stop button title'
    }
});
const Controls = function (props) {
    const {
        active,
        className,
        closePanel,
        intl,
        onGreenFlagClick,
        onStopAllClick,
        toCode,
        turbo,
        onChangeWidth,
        isFullScreen,
        ...componentProps
    } = props;
    return (
        <div
            className={classNames(styles.controlsContainer, className)}
            {...componentProps}
        >
            {isFullScreen ? <div
                className={classNames(styles.controlBtn, className)}
            >
                <GreenFlag
                    active={active}
                    title={intl.formatMessage(messages.goTitle)}
                    onClick={onGreenFlagClick}
                />
                <StopAll
                    active={active}
                    title={intl.formatMessage(messages.stopTitle)}
                    onClick={onStopAllClick}
                />
            </div> : null}

            <ToCode
                active={active}
                className={classNames(styles.download, className)}
                onClick={toCode}
            />

            {/* <CodePanel
                className={classNames(styles.codepanel, className)}
            /> */}
            {/* {turbo ? (
                <TurboMode />
            ) : null} */}
        </div>
    );
};

Controls.propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    closePanel: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    onChangeWidth: PropTypes.func.isRequired,
    onGreenFlagClick: PropTypes.func.isRequired,
    onStopAllClick: PropTypes.func.isRequired,
    toCode: PropTypes.func.isRequired,
    turbo: PropTypes.bool
};

Controls.defaultProps = {
    active: false,
    turbo: false
};

export default injectIntl(Controls);
